module.exports = __webpack_public_path__ + "img/logoMini.b634dff6.png";